import latexJson from "./latex.json";
const latexKeys = Object.keys(latexJson);
const latexExpFirstChars = latexKeys
    .reduce((acc, key) => {
    if (!acc.includes(key[0]))
        acc.push(key[0]);
    return acc;
}, []);
export const subLatexTerms = (bibItem) => {
    bibItem
        .entries
        .forEach(entry => {
        entry
            .tags
            .forEach(tag => {
            let doTest = false;
            for (const firstChar of latexExpFirstChars) {
                if (tag.fieldValue.includes(firstChar))
                    doTest = true;
            }
            if (!doTest)
                return;
            const parts = [];
            const dollarGroups = [...tag.fieldValue.matchAll(/\$(.*?)\$/g)];
            let lastIndex = 0;
            for (const dollarGroup of dollarGroups) {
                if (dollarGroup.index == null)
                    continue;
                if (lastIndex !== dollarGroup.index)
                    parts.push({
                        text: tag.fieldValue.slice(lastIndex, dollarGroup.index),
                        allowSub: true,
                    });
                parts.push({
                    text: tag.fieldValue.slice(dollarGroup.index, dollarGroup.index + dollarGroup[0].length),
                    allowSub: false,
                });
                lastIndex = dollarGroup.index + dollarGroup[0].length;
            }
            if (lastIndex < tag.fieldValue.length)
                parts.push({
                    text: tag.fieldValue.slice(lastIndex, tag.fieldValue.length),
                    allowSub: true,
                });
            for (const [key, val] of Object.entries(latexJson)) {
                for (const part of parts.filter(p => p.allowSub)) {
                    if (part.text.includes(key))
                        part.text = part.text.replace(key, val);
                }
            }
            tag.fieldValue = parts.map(p => p.text).join('');
        });
    });
    return bibItem;
};
